import { render } from "./ProsesUnitKategori.vue?vue&type=template&id=6a9de945"
import script from "./ProsesUnitKategori.vue?vue&type=script&lang=js"
export * from "./ProsesUnitKategori.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__